import { useFormik } from 'formik';
import { useEffect } from 'react';
import {
    CasesGeneral,
    CasesGenerallCallInfo,
    CasesGeneralClaims,
} from '../../../../../../shared/types/modules/cases-general';
import { ISelect } from '../../../../../../shared/types/shared';

export const useCasesGeneralInfo = (casesGeneral?: CasesGeneral) => {
    const formik = useFormik({
        initialValues: {
            createdBy: '',
            updatedBy: '',
            callId: '',
            policie: '',
            channel: '' as string | ISelect,
            typification: '' as string | ISelect,
            plate: '',
            dateEvent: '' as string | Date,
            description: '',
            observation: '',
            status: '' as string | ISelect,
            branch: '' as string | ISelect,
            product: '' as string | ISelect,
            officie: '' as string | ISelect,
            correspondenceFiling: '',
        },
        onSubmit: console.log,
    });

    useEffect(() => {
        const {
            createdBy,
            updatedBy,
            callInfo = {} as CasesGenerallCallInfo,
            claims = {} as CasesGeneralClaims,
            typification = {} as CasesGeneral['typification'],
        } = casesGeneral || {};

        const typification1 =
            typeof typification?.typification1 === 'object' &&
            'name' in typification.typification1
                ? typification.typification1.name
                : (typification?.typification1 as string) || '';

        const typification2 =
            typeof typification?.typification2 === 'object' &&
            'name' in typification.typification2
                ? typification.typification2.name
                : (typification?.typification2 as string) || '';

        const typificationName = [typification1, typification2]
            .filter((name) => name)
            .join(' | ');

        formik.setValues({
            createdBy: createdBy
                ? `(${createdBy.username}) ${createdBy.name} ${createdBy.surname}`
                : '',
            updatedBy: updatedBy
                ? `(${updatedBy.username}) ${updatedBy.name} ${updatedBy.surname}`
                : '',
            callId: callInfo.callId || '',
            policie: callInfo.policie || '',
            plate: callInfo.plate || '',
            channel: callInfo.channel || '',
            dateEvent: claims.dateEvent || '',
            description: claims.description || '',
            observation: claims.observation || '',
            status: claims.status || '',
            branch: callInfo.branch || '',
            product: callInfo.product || '',
            typification: typificationName,
            officie: callInfo.officie || '',
            correspondenceFiling: claims?.correspondenceFiling || '',
        });
    }, [casesGeneral]);

    const getChannelName = () =>
        typeof formik.values.channel === 'object'
            ? (formik.values.channel as ISelect)?.name || ''
            : formik.values.channel;

    const getStatusName = () =>
        typeof formik.values.status === 'object'
            ? (formik.values.status as ISelect)?.name || ''
            : formik.values.status;

    const getBranchName = () =>
        typeof formik.values.branch === 'object'
            ? (formik.values.branch as ISelect)?.name || ''
            : formik.values.branch;

    const getProductName = () =>
        typeof formik.values.product === 'object'
            ? (formik.values.product as ISelect)?.name || ''
            : formik.values.product;

    const getDateEventFormatted = () =>
        typeof formik.values.dateEvent === 'string'
            ? formik.values.dateEvent
            : formik.values.dateEvent?.toISOString();

    const getTypificationNames = () => {
        const typification1 =
            typeof casesGeneral?.typification?.typification1 === 'object'
                ? casesGeneral?.typification?.typification1.name
                : casesGeneral?.typification?.typification1 || '';

        const typification2 =
            typeof casesGeneral?.typification?.typification2 === 'object'
                ? casesGeneral?.typification?.typification2.name
                : casesGeneral?.typification?.typification2 || '';

        return [typification1, typification2]
            .filter((name) => name) // Filtrar valores vacíos
            .join(' | '); // Concatenar con separador
    };

    const getOfficieName = () =>
        typeof formik.values.officie === 'object'
            ? (formik.values.officie as ISelect)?.name || ''
            : formik.values.officie;
    return {
        formik,
        getChannelName,
        getStatusName,
        getDateEventFormatted,
        getBranchName,
        getProductName,
        getTypificationNames,
        getOfficieName,
    };
};
